export default "__VITE_ASSET__8759b184__"